module.exports = __webpack_public_path__ + "static/img/civic.0023e05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/civic.png
// module id = bHqs
// module chunks = 0